module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/mobile_8c7728.mp4";